import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, BadgeCheck, Radar } from "lucide-react";
import { useLang } from "@/i18n";

const EASE = [0.16, 1, 0.3, 1];

export function Rahalty() {
  const { t } = useLang();
  const features = [t("rahalty_f1"), t("rahalty_f2"), t("rahalty_f3"), t("rahalty_f4")];
  return (
    <section id="rahalty" data-testid="rahalty-section" className="relative py-20 lg:py-28 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.85, ease: EASE }}
          className="relative overflow-hidden rounded-3xl border border-blue-500/20 bg-gradient-to-br from-[#0B1526] via-[#0A1830] to-[#060B14] p-8 sm:p-12 lg:p-16 shadow-[0_30px_80px_rgba(2,6,17,0.55)]"
          data-always-dark
        >
          <div className="absolute inset-0 grid-lines opacity-40" />
          <div className="relative grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 rounded-full bg-blue-600/20 blur-3xl scale-110" />
                <img
                  src="/assets/brand/logo-rahalty.png"
                  alt="Rahalty — flight operations management system logo"
                  data-testid="rahalty-logo"
                  className="relative w-56 sm:w-72 lg:w-80 h-auto animate-float drop-shadow-[0_20px_50px_rgba(0,0,0,0.6)]"
                />
              </div>
            </div>
            <div>
              <div className="flex flex-wrap items-center gap-3">
                <span className="font-mono-tag text-xs tracking-[0.3em] uppercase text-blue-400">{t("rahalty_eyebrow")}</span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-blue-600/15 border border-blue-500/30 px-3 py-1 text-[11px] font-semibold text-blue-300" data-testid="rahalty-badge">
                  <BadgeCheck size={12} />
                  {t("rahalty_badge")}
                </span>
              </div>
              <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-white" data-testid="rahalty-title">{t("rahalty_title")}</h2>
              <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-400">{t("rahalty_desc")}</p>
              <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="rahalty-features">
                {features.map((f) => (
                  <div key={f} className="flex items-center gap-2.5 rounded-xl border border-blue-500/15 bg-[#081020]/70 px-4 py-3">
                    <Radar size={15} className="shrink-0 text-blue-400" />
                    <span className="text-sm font-medium text-slate-200">{f}</span>
                  </div>
                ))}
              </div>
              <Link
                data-testid="rahalty-explore-button"
                to="/rahalty"
                className="mt-7 inline-flex items-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-sm font-bold text-white hover:bg-blue-500 transition-colors duration-200 shadow-[0_0_24px_rgba(37,99,235,0.4)]"
              >
                {t("rahalty_cta")}
                <ArrowLeft size={16} className="ltr:rotate-180" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
